import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class SupplyAccountLinkCtrl implements IController {
  account: AccountModel;
}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountLink', {
    bindings: {
      account: '<'
    },
    template: require('./supply-account-link.html').default,
    controller: SupplyAccountLinkCtrl
  });
